// extracted by mini-css-extract-plugin
export default {"container":"Input_container__Kj02c","warning":"Input_warning__q9trT"};